var exports = {
  "b1": "UserProfileBadges.module__containerInline___b29ndH",
  "v4": "UserProfileBadges.module__containerInlineMobile___b29ndH",
  "D6": "UserProfileBadges.module__containerInlineDesktop___b29ndH",
  "U3": "UserProfileBadges.module__containerOverlay___b29ndH",
  "Qk": "UserProfileBadges.module__badgeMobile___b29ndH",
  "EJ": "UserProfileBadges.module__badgeDesktop___b29ndH",
  "J1": "UserProfileBadges.module__componentBadge___b29ndH",
  "yH": "UserProfileBadges.module__componentBadgeIcon___b29ndH",
  "vI": "UserProfileBadges.module__multilineTooltip___b29ndH",
  "X8": "UserProfileBadges.module__sequenceBadge___b29ndH",
  "Fi": "UserProfileBadges.module__sequenceBadgeMobile___b29ndH",
  "Hd": "UserProfileBadges.module__sequenceBadgeDesktop___b29ndH",
  "nf": "UserProfileBadges.module__link___b29ndH",
  "Oc": "UserProfileBadges.module__badgeButton___b29ndH",
  "kM": "UserProfileBadges.module__moreChip___b29ndH",
  "_y": "UserProfileBadges.module__moreChipMobile___b29ndH",
  "aw": "UserProfileBadges.module__containerRow___b29ndH",
  "kC": "UserProfileBadges.module__containerRowMobile___b29ndH",
};

module.exports = exports;
